import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { VERIFY_OTP, VERIFY_OTP_SUCCESS, VERIFY_OTP_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* VerifyOtp({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/profile/verify-otp`,
      method: 'POST',
      data: payload.data,
      // isFormData: true,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: VERIFY_OTP_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: VERIFY_OTP_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: VERIFY_OTP_ERROR, payload: error });
  }
}

export function* watchVerifyOtp() {
  yield takeEvery(VERIFY_OTP, VerifyOtp);
}

function* VerifyOtpSaga() {
  yield all([fork(watchVerifyOtp)]);
}

export default VerifyOtpSaga;
